import { render } from "./ProjectBudgetCostModel.vue?vue&type=template&id=66b0e1b2&scoped=true"
import script from "./ProjectBudgetCostModel.vue?vue&type=script&lang=js"
export * from "./ProjectBudgetCostModel.vue?vue&type=script&lang=js"

import "./ProjectBudgetCostModel.vue?vue&type=style&index=0&id=66b0e1b2&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b0e1b2"]])

export default __exports__